// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledWaitingToStartTransmissionMessage = styled((props) => (
	<Block {...props} />
))`
	position: absolute;
	top: 0.75rem;
	left: 1rem;
	width: calc(100% - 3rem - 90px);
	padding: 1rem;
	text-align: center;
	border-radius: var(--dz-sys-box-border-radius);
	${({ theme: { colors } }) => css`
		color: ${colors.whiteAlways};
		background-color: ${colors.blackAlways};
	`}
`;

// #####################################################
